
export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAIL = "UPLOAD_FILE_FAIL";
export const UPLOAD_FILE = "UPLOAD_FILE"
export const REMOVE_FILE = "REMOVE_FILE"
export const API_FAIL = "API_FAIL"



export const UPLOAD_PROFILE_IMG = "UPLOAD_PROFILE_IMG";
export const UPLOAD_PROFILE_IMG_SUCCESS = "UPLOAD_PROFILE_IMG_SUCCESS";
export const UPLOAD_PROFILE_IMG_FAIL = "UPLOAD_PROFILE_IMG_FAIL";

export const DELETE_PROFILE_IMG = "DELETE_PROFILE_IMG";
export const DELETE_PROFILE_IMG_SUCCESS = "DELETE_PROFILE_IMG_SUCCESS";
export const DELETE_PROFILE_IMG_FAIL = "DELETE_PROFILE_IMG_FAIL";